import type { ResponseBaseGetOneResponseEntitySupplementTag } from "@classes-service-types/index.ts";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "./utils.js";

const entitySupplementService = {
  async getOneEntitySupplement(
    entityId: string,
  ): Promise<AxiosResponse<ResponseBaseGetOneResponseEntitySupplementTag>> {
    return await learningServiceRequest<ResponseBaseGetOneResponseEntitySupplementTag>({
      method: "get",
      url: `/entity_supplement/${entityId}`,
      failureMessage: "Error loading Entity Supplement data",
    });
  },
};

export default entitySupplementService;
